import { Controller } from '@hotwired/stimulus'

export default class CodeExampleController extends Controller {
  static targets = [
    'content',
    'copyButton',
    'copyLabel',
    'source',
    'toggle',
    'toggleLabel'
  ]

  static values = {
    copiedLabel: String,
    copyLabel: String,
    hideLabel: String,
    showLabel: String
  }

  disconnect() {
    window.clearTimeout(this.copyResetTimeout)
  }

  toggle() {
    const isOpen = this.contentTarget.hidden

    this.contentTarget.hidden = !isOpen
    this.toggleTarget.setAttribute('aria-expanded', String(isOpen))
    this.toggleLabelTarget.textContent = isOpen
      ? this.hideLabelValue
      : this.showLabelValue
  }

  async copy() {
    const text = this.sourceTarget.textContent
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
      this.showCopiedState()
    } catch (error) {
      console.error('Failed to copy code: ', error)
    }
  }

  showCopiedState() {
    window.clearTimeout(this.copyResetTimeout)
    this.copyButtonTarget.classList.add('is-copied')
    this.copyButtonTarget.setAttribute('aria-label', this.copiedLabelValue)
    this.copyButtonTarget.setAttribute('title', this.copiedLabelValue)
    this.copyLabelTarget.textContent = this.copiedLabelValue

    this.copyResetTimeout = window.setTimeout(() => {
      this.copyButtonTarget.classList.remove('is-copied')
      this.copyButtonTarget.setAttribute('aria-label', this.copyLabelValue)
      this.copyButtonTarget.setAttribute('title', this.copyLabelValue)
      this.copyLabelTarget.textContent = this.copyLabelValue
    }, 2000)
  }
}
